import React from "react";
import { Link } from "react-router-dom";
import { getSiteBrand } from "@/lib/siteHosts";

const DashboardFooter = () => (
  <footer className="py-6 px-6 border-t border-white/5">
    <div className="max-w-4xl mx-auto text-center">
      <div className="flex items-center justify-center gap-6 mb-4">
        <Link
          to="/privacy-policy"
          className="text-[#9CA3AF] text-sm hover:text-[#F3F4F6] transition-colors"
        >
          Privacy Policy
        </Link>
        <span className="text-[#9CA3AF]/30">|</span>
        <Link
          to="/terms"
          className="text-[#9CA3AF] text-sm hover:text-[#F3F4F6] transition-colors"
        >
          Terms of Service
        </Link>
        <span className="text-[#9CA3AF]/30">|</span>
        <Link
          to="/dpa"
          className="text-[#9CA3AF] text-sm hover:text-[#F3F4F6] transition-colors"
        >
          DPA
        </Link>
      </div>
      <p className="text-[#9CA3AF]/60 text-xs font-mono">
        © {new Date().getFullYear()} {getSiteBrand().name}. All rights reserved.
      </p>
    </div>
  </footer>
);

export default DashboardFooter;
